module.exports = __webpack_public_path__ + "img/eye-open.b759b065.svg";